var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpShowEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C6.38926 0 3.06398 1.87252 0.776203 5.03412C0.242914 5.76889 0 6.71279 0 7.61749C0 8.5219 0.242819 9.46561 0.775861 10.2003C3.06364 13.3622 6.38908 15.235 10 15.235C13.6107 15.235 16.936 13.3624 19.2238 10.2008C19.7571 9.46599 20 8.52209 20 7.61749C20 6.71298 19.7572 5.76927 19.2241 5.0346C16.9363 1.8727 13.6109 0 10 0ZM7.86429 7.62224C7.86429 6.44046 8.81823 5.4865 10 5.4865C11.1818 5.4865 12.1357 6.44046 12.1357 7.62224C12.1357 8.80401 11.1818 9.75797 10 9.75797C8.81823 9.75797 7.86429 8.80401 7.86429 7.62224ZM10 4.06267C8.03189 4.06267 6.44046 5.6541 6.44046 7.62224C6.44046 9.59034 8.03189 11.1818 10 11.1818C11.9682 11.1818 13.5596 9.59034 13.5596 7.62224C13.5596 5.6541 11.9682 4.06267 10 4.06267Z",
    fill: "#FF6B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpShowEye);
export default __webpack_public_path__ + "static/media/otp-show-eye.4bfb8fd31ac4c4255519a9bd8962679b.svg";
export { ForwardRef as ReactComponent };